import { render, staticRenderFns } from "./OcpcList.vue?vue&type=template&id=39defde4"
import script from "./OcpcList.vue?vue&type=script&lang=js"
export * from "./OcpcList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports